// src/components/StatCard.tsx
import React from 'react';
import { cn } from '../lib/utils';

interface StatCardProps {
  label: string;
  value: number | string;
  icon: React.ReactNode;
  className?: string;
}

export function StatCard({ label, value, icon, className }: StatCardProps) {
  return (
    <div className={cn("bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-4", className)}>
      <div className="p-3 bg-slate-50 rounded-lg border border-slate-100">
        {icon}
      </div>
      <div>
        <p className="text-sm text-slate-500 font-medium">{label}</p>
        <p className="text-2xl font-bold text-slate-900 font-display">{value}</p>
      </div>
    </div>
  );
}